import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, cn } from "@tosize/ui";
import {
	type AnchorHTMLAttributes,
	type ButtonHTMLAttributes,
	createElement,
	forwardRef,
} from "react";

type ComponentVariant = AnchorHTMLAttributes<HTMLAnchorElement> &
	ButtonHTMLAttributes<HTMLButtonElement>;

export interface ShortLinkButtonProps {
	component: "a" | "button";
	title: string;
	subtitle?: string;
	loading?: boolean;
}

export const ShortLinkButton = forwardRef<
	ComponentVariant,
	ShortLinkButtonProps & ComponentVariant
>(function ShortLinkRef(props, ref) {
	const { component, title, subtitle, loading, ...remainingProps } = props;

	return createElement(
		component,
		{
			...remainingProps,
			title,
			type: component === "button" ? (remainingProps.type ?? "button") : undefined,
			className: cn(
				"group cursor-pointer appearance-none focus:outline-none",
				remainingProps.className,
			),
			ref,
		},
		<div className="flex items-baseline justify-between rounded border border-primary px-4 py-2 child:leading-tight group-hover:bg-primary-light group-focus-visible:bg-primary-light motion-safe:transition">
			<Typography
				variant="paragraph"
				size="text-sm"
				className="mr-2 inline-flex items-center justify-center"
			>
				{loading && (
					<FontAwesomeIcon icon={faSpinnerThird} className="mr-2 animate-spin" fixedWidth />
				)}

				<span>{title}</span>
			</Typography>

			{!!subtitle && (
				<Typography
					variant="paragraph-italic"
					size="text-xs"
					className="whitespace-nowrap text-secondary"
				>
					{subtitle}
				</Typography>
			)}
		</div>,
	);
});
